import * as React from "react";
import type { SVGProps } from "react";
const SvgPhasesIndicator = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5.313 10-1.875 1.875L1.562 10"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.437 10c0 .578.072 1.138.196 1.68M18.438 10a7.5 7.5 0 0 0-7.5-7.5 7.5 7.5 0 0 0-7.5 7.5M10.938 17.5a7.5 7.5 0 0 0 7.5-7.5M4.795 14.297a7.49 7.49 0 0 0 6.142 3.204"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m13.747 12.39-3.044-1.81V6.652"
    />
  </svg>
);
export default SvgPhasesIndicator;
